import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import _, { map } from 'lodash'

import { Segment, Grid, Header, Table, Icon, Button } from 'semantic-ui-react'

import Loading from '../../components/common/loading'
import PartnerRow from '../../components/partners/row'
import PartnerActions from '../../reducers/partnerReducer'

class Partners extends Component {
  componentDidMount() {
    const { loaded, fetchPartners } = this.props

    if (!loaded) {
      fetchPartners()
    }
  }

  renderPartnerRows = () => {
    const { partners } = this.props
    const partnerRows = map(partners, (partner, key) => {
      return <PartnerRow key={key} data={partner} fireKey={key} />
    })

    return partnerRows
  }

  render() {
    const { loading, partners } = this.props

    return (
      <div>
        <Loading active={loading} />
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
              <Header size="large" style={{ display: 'inline-block' }}>
                List Partners ({_.size(partners)})
              </Header>
              <Link to="/partners/new" style={{ float: 'right' }}>
                <Button icon color="black">
                  <Icon name="add" />
                </Button>
              </Link>

              <Table basic="very">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell style={{ width: '15%' }}>Name</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '15%' }}>Phone</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '15%' }} textAlign="center">
                      Restaurant
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '15%' }} textAlign="center">
                      Branch
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '10%' }} textAlign="center">
                      Logged
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '10%' }} textAlign="center">
                      App
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ width: '10%' }} textAlign="center">
                      Last Session
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{}} textAlign="center">
                      Action
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>{this.renderPartnerRows()}</Table.Body>
              </Table>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    partners: state.partners.data,
    loading: state.partners.loading,
    loaded: state.partners.loaded,
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch,
  fetchPartners: () => dispatch(PartnerActions.fetchPartnersRequest()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Partners)



// WEBPACK FOOTER //
// ./src/containers/partners/index.js